// AUTO-GENERATED by scripts/gen-recipes.mjs. Do not edit.
import type { Recipe } from '../types';
import alPastor from './al-pastor/recipe';
import bbqPorkRub from './bbq-pork-rub/recipe';
import bbqSauce from './bbq-sauce/recipe';
import carnitas from './carnitas/recipe';
import chickFilASauce from './chick-fil-a-sauce/recipe';
import chickenKatsu from './chicken-katsu/recipe';
import cornbread from './cornbread/recipe';
import friedChickenSandwich from './fried-chicken-sandwich/recipe';
import friedFishTacos from './fried-fish-tacos/recipe';
import gochujangSauce from './gochujang-sauce/recipe';
import jalapenoPoppers from './jalapeno-poppers/recipe';
import japaneseCurry from './japanese-curry/recipe';
import koreanFriedChicken from './korean-fried-chicken/recipe';
import lasagna from './lasagna/recipe';
import macAndCheese from './mac-and-cheese/recipe';
import mashedSweetPotatoes from './mashed-sweet-potatoes/recipe';
import picoDeGallo from './pico-de-gallo/recipe';
import porkChop from './pork-chop/recipe';
import porkRibs from './pork-ribs/recipe';
import pulledPork from './pulled-pork/recipe';
import spicyVodkaRigatoni from './spicy-vodka-rigatoni/recipe';
import steak from './steak/recipe';
import sweetPotatoCasserole from './sweet-potato-casserole/recipe';

export interface RecipeEntry {
  slug: string;
  recipe: Recipe;
  hasHero: boolean;
  hasOg: boolean;
  heroDims?: { width: number; height: number };
}

export const recipes: RecipeEntry[] = [
  { slug: 'al-pastor', recipe: alPastor, hasHero: true, hasOg: true, heroDims: { width: 704, height: 692 } },
  { slug: 'bbq-pork-rub', recipe: bbqPorkRub, hasHero: false, hasOg: false },
  { slug: 'bbq-sauce', recipe: bbqSauce, hasHero: false, hasOg: false },
  { slug: 'carnitas', recipe: carnitas, hasHero: false, hasOg: false },
  { slug: 'chick-fil-a-sauce', recipe: chickFilASauce, hasHero: true, hasOg: true, heroDims: { width: 767, height: 767 } },
  { slug: 'chicken-katsu', recipe: chickenKatsu, hasHero: true, hasOg: true, heroDims: { width: 768, height: 1024 } },
  { slug: 'cornbread', recipe: cornbread, hasHero: true, hasOg: true, heroDims: { width: 1534, height: 1503 } },
  { slug: 'fried-chicken-sandwich', recipe: friedChickenSandwich, hasHero: true, hasOg: true, heroDims: { width: 767, height: 767 } },
  { slug: 'fried-fish-tacos', recipe: friedFishTacos, hasHero: true, hasOg: true, heroDims: { width: 1024, height: 768 } },
  { slug: 'gochujang-sauce', recipe: gochujangSauce, hasHero: true, hasOg: true, heroDims: { width: 697, height: 592 } },
  { slug: 'jalapeno-poppers', recipe: jalapenoPoppers, hasHero: true, hasOg: true, heroDims: { width: 1024, height: 841 } },
  { slug: 'japanese-curry', recipe: japaneseCurry, hasHero: true, hasOg: true, heroDims: { width: 768, height: 1024 } },
  { slug: 'korean-fried-chicken', recipe: koreanFriedChicken, hasHero: true, hasOg: true, heroDims: { width: 697, height: 592 } },
  { slug: 'lasagna', recipe: lasagna, hasHero: false, hasOg: false },
  { slug: 'mac-and-cheese', recipe: macAndCheese, hasHero: true, hasOg: true, heroDims: { width: 704, height: 692 } },
  { slug: 'mashed-sweet-potatoes', recipe: mashedSweetPotatoes, hasHero: false, hasOg: false },
  { slug: 'pico-de-gallo', recipe: picoDeGallo, hasHero: false, hasOg: false },
  { slug: 'pork-chop', recipe: porkChop, hasHero: true, hasOg: true, heroDims: { width: 1533, height: 1534 } },
  { slug: 'pork-ribs', recipe: porkRibs, hasHero: true, hasOg: true, heroDims: { width: 704, height: 692 } },
  { slug: 'pulled-pork', recipe: pulledPork, hasHero: true, hasOg: true, heroDims: { width: 768, height: 768 } },
  { slug: 'spicy-vodka-rigatoni', recipe: spicyVodkaRigatoni, hasHero: false, hasOg: false },
  { slug: 'steak', recipe: steak, hasHero: true, hasOg: true, heroDims: { width: 767, height: 842 } },
  { slug: 'sweet-potato-casserole', recipe: sweetPotatoCasserole, hasHero: false, hasOg: false },
].sort((a, b) => a.recipe.title.localeCompare(b.recipe.title));
